import { render } from "./DashboardCard.vue?vue&type=template&id=99d9d37e"
import script from "./DashboardCard.vue?vue&type=script&lang=js"
export * from "./DashboardCard.vue?vue&type=script&lang=js"

import "./DashboardCard.vue?vue&type=style&index=0&id=99d9d37e&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__